import React from 'react';
import styled from 'styled-components';
import { SVGIcon, Menu as MenuComponent } from '@pearsontechnology/aero-components';
import { Link } from 'react-router-dom';

export const ContentWrapper = styled.div`
  padding: 0 30px;
  color: ${(props) => props.theme['color.text.light']};
`;

export const PluginColumnText = styled.div`
  font-size: 14px;
  line-height: 18px;
`;

export const ListTitle = styled.div`
  text-transform: uppercase;
  padding: 40px 0 15px 0;
  color: ${(props) => props.theme['color.text.light']};
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.8px;
  line-height: 14px;
`;

export const PluginName = styled(Link)`
  width: 100%;
  display: flex;
  font-size: 14px;
  align-items: center;
  text-decoration: none;
  color: ${(props) => props.theme['color.text.body']};
`;

const PluginIconDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  margin: 1px 10px 1px 1px;
  flex: 0 0 auto;
`;

export const PluginIcon = () => (
  <PluginIconDiv>
    <SVGIcon
      primary
      icon="duotonePlugins"
      viewBox="0 0 24 24"
    />
  </PluginIconDiv>
);

export const Menu = styled(MenuComponent)`
  margin-top: 10px;
  word-break: normal;
`;

export const MenuListItemText = styled.div`
  margin: 0 8px;
`;
